import { useScrollReveal, useScrollRevealGroup } from '@/hooks/useScrollReveal';

const steps = [
  {
    num: '01',
    title: 'Находим спрос',
    desc: 'Выявляем аудиторию, которая уже ищет ваш продукт или услугу.',
  },
  {
    num: '02',
    title: 'ИИ пишет первым',
    desc: 'Отправляет понятное первое сообщение и уточняет актуальность интереса.',
  },
  {
    num: '03',
    title: 'Квалифицирует и напоминает',
    desc: 'Уточняет потребность, отвечает на вопросы и автоматически напоминает о себе, если клиент не ответил.',
  },
  {
    num: '04',
    title: 'Передаёт в отдел продаж',
    desc: 'Менеджер получает контакт, историю общения и понятную задачу клиента.',
  },
];

export default function LTKHowItWorks() {
  const { ref: labelRef, revealed: labelRevealed } = useScrollReveal();
  const { ref: titleRef, revealed: titleRevealed } = useScrollReveal({ delay: 100 });
  const { containerRef: stepsRef, revealedCount: stepsRevealed } = useScrollRevealGroup<HTMLDivElement>(4);

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="text-center mb-12 md:mb-16">
          <span ref={labelRef} className={`text-[12px] font-semibold uppercase tracking-[0.18em] text-primary-600 reveal-fade-up ${labelRevealed ? 'revealed' : ''}`}>
            Как работаем
          </span>
          <h2 ref={titleRef} className={`mt-4 font-display font-extrabold text-[34px] md:text-[46px] leading-[1.1] tracking-tightest text-foreground-950 reveal-fade-up ${titleRevealed ? 'revealed' : ''}`}>
            Как вы получаете готовые заявки — за 4 шага
          </h2>
        </div>

        <div ref={stepsRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 max-w-5xl mx-auto">
          {steps.map((step, i) => (
            <div
              key={step.num}
              className={`relative rounded-2xl bg-background-100 border border-background-200/70 p-6 md:p-7 hover:border-primary-500/40 transition-all duration-300 group reveal-fade-up ${i < stepsRevealed ? 'revealed' : ''}`}
              style={i < stepsRevealed ? { transitionDelay: `${i * 120}ms` } : undefined}
            >
              <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors">
                <span className="font-display font-bold text-sm text-primary-700">{step.num}</span>
              </div>
              <h3 className="font-display font-bold text-[17px] text-foreground-950 mb-2">{step.title}</h3>
              <p className="text-[14.5px] text-foreground-500 leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}